<script lang="ts">
    import { getLanguage, selectLanguage } from '../helpers/url';
    import { openModal } from 'svelte-modals';
    import HelpModal from './modals/HelpModal.svelte';

    const currentLang = getLanguage();

    function changeLanguage(e) {
        const options = e.target.options;
        const lang = options[options.selectedIndex].value;
        selectLanguage(lang);
    }
    function handleClick() {
        openModal(HelpModal);
    }
</script>

<div class="language-wrapper">
    <!-- <i class="fa fa-question" on:click={handleClick} /> -->
    <div class="input-wrapper icon price">
        <select
            class="input-field"
            on:change={changeLanguage}
            type="text"
            placeholder="Language"
        >
            <option value="en" selected={currentLang === 'en' ? true : false}>
                English
            </option>
            <option value="ja" selected={currentLang === 'ja' ? true : false}>
                日本語
            </option>
            <option value="fr" selected={currentLang === 'fr' ? true : false}>
                French
            </option>
            <option value="zh" selected={currentLang === 'zh' ? true : false}>
                中文
            </option>
        </select>
    </div>
</div>

<style>
    .language-wrapper {
        display: flex;
    }

    .language-wrapper > i.fa-question {
        cursor: pointer;
        width: auto;
        font-size: 20px;
        margin-right: 10px;
    }

    .language-wrapper > i {
        width: 55px;
        font-size: 38px;
        line-height: 29px;
        color: grey;
    }

    .input-wrapper {
        flex: 1;
        height: 35px;
    }

    .input-field {
        height: 100%;
    }
</style>
